module.exports = __webpack_public_path__ + "static/info2-73fe5025828b5795364dacc9afb44030.png";